import styles from '../../MetaReportViewer.module.css';

export const CAMPAIGN_SETTINGS = [
  { key: 'objective', label: 'Objective' },
  { key: 'buying_type', label: 'Buying Type' },
  { key: 'status', label: 'Status' },
  { key: 'budget_type', label: 'Budget Type' },
  { key: 'total_budget', label: 'Total Budget' },
  { key: 'budget_currency', label: 'Currency' },
  { key: 'date_start', label: 'Start Date' },
  { key: 'date_stop', label: 'End Date' },
  { key: 'duration_days', label: 'Duration (days)' },
];

export const ADSET_TARGETING = [
  { key: 'audience_type', label: 'Audience Type' },
  { key: 'audience_description', label: 'Audience Description' },
  { key: 'geo_targeting', label: 'Geo Targeting' },
  { key: 'age_min', label: 'Age Min' },
  { key: 'age_max', label: 'Age Max' },
  { key: 'age_range', label: 'Age Range' },
  { key: 'gender', label: 'Gender' },
  { key: 'placements', label: 'Placements' },
];

export const ADSET_BIDDING = [
  { key: 'optimization_goal', label: 'Optimization Goal' },
  { key: 'attribution_setting', label: 'Attribution Setting' },
  { key: 'bid_strategy', label: 'Bid Strategy' },
  { key: 'bid_amount_raw', label: 'Bid Amount (raw)' },
  { key: 'bid_value', label: 'Bid Value' },
  { key: 'daily_budget', label: 'Daily Budget' },
  { key: 'lifetime_budget', label: 'Lifetime Budget' },
];

export const AD_CREATIVE = [
  { key: 'creative_type', label: 'Creative Type' },
  { key: 'creative_format', label: 'Creative Format' },
  { key: 'primary_text', label: 'Primary Text' },
  { key: 'headline', label: 'Headline' },
  { key: 'call_to_action', label: 'Call to Action' },
  { key: 'destination_url', label: 'Destination URL' },
  { key: 'video_hold_rate', label: 'Video Hold Rate' },
];

export const CAMPAIGN_IDS = [
  { key: 'campaign_id', label: 'Campaign ID' },
];

export const ADSET_IDS = [
  { key: 'campaign_id', label: 'Campaign ID' },
  { key: 'adset_id', label: 'Ad Set ID' },
];

export const AD_IDS = [
  { key: 'campaign_id', label: 'Campaign ID' },
  { key: 'adset_id', label: 'Ad Set ID' },
  { key: 'ad_id', label: 'Ad ID' },
];

export const fmt = (v, decimals = 2) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return n % 1 === 0
    ? n.toLocaleString()
    : n.toLocaleString(undefined, { maximumFractionDigits: decimals });
};

export const MONETARY_FIELD_KEYS = new Set([
  'spend',
  'revenue',
  'attributed_revenue',
  'cpm',
  'cpc',
  'cac',
  'aov',
  'avg_30_day_cltv',
  'avg_60_day_cltv',
  'avg_90_day_cltv',
  '30_day_cltv',
  '60_day_cltv',
  '90_day_cltv',
  'total_budget',
  'daily_budget',
  'lifetime_budget',
  'bid_value',
  'spend_per_day',
  'contribution_after_marketing',
  'revenue_per_click',
  'revenue_per_1000_impressions',
]);

export const resolveCurrency = (row = {}, fallbackCurrency = null) =>
  row?.budget_currency || row?.currency || fallbackCurrency || null;

export const fmtMoney = (value, currency, decimals = 2) => {
  const formatted = fmt(value, decimals);
  if (formatted === '—') return formatted;
  return currency ? `${currency} ${formatted}` : formatted;
};

export const roasColor = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n) || n === 0) return styles.kpiNeutral;
  if (n >= 2) return styles.kpiGood;
  if (n >= 1) return styles.kpiWarn;
  return styles.kpiBad;
};

const NUM_FIELDS = [
  'spend', 'impressions', 'clicks', 'reach', 'conversions', 'revenue',
  'add_to_cart', 'initiate_checkout', 'landing_page_views',
  'video_views', 'video_thruplays', 'video_p25', 'engagements', 'link_clicks',
];

export const aggregateRows = (rows) => {
  if (!rows.length) return {};
  const sums = {};
  NUM_FIELDS.forEach((key) => {
    sums[key] = rows.reduce((acc, row) => acc + (Number(row[key]) || 0), 0);
  });
  sums.roas = sums.spend > 0 ? Number((sums.revenue / sums.spend).toFixed(3)) : 0;
  sums.ctr = sums.impressions > 0 ? Number(((sums.clicks / sums.impressions) * 100).toFixed(2)) : 0;
  sums.cpm = sums.impressions > 0 ? Number(((sums.spend / sums.impressions) * 1000).toFixed(2)) : 0;
  sums.cpc = sums.clicks > 0 ? Number((sums.spend / sums.clicks).toFixed(2)) : null;
  sums.conversion_rate = sums.clicks > 0 ? Number(((sums.conversions / sums.clicks) * 100).toFixed(3)) : 0;
  sums.hook_rate = sums.impressions > 0 ? Number(((sums.video_views / sums.impressions) * 100).toFixed(2)) : 0;
  sums.link_ctr = sums.impressions > 0 && sums.link_clicks > 0
    ? Number(((sums.link_clicks / sums.impressions) * 100).toFixed(2))
    : 0;
  return { ...rows[rows.length - 1], ...sums };
};
